module.exports = __webpack_public_path__ + "static/img/moments_image2.208d9d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moments_image2.png
// module id = onqU
// module chunks = 1